import { useMemo } from 'react';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import ConceptsBarItem from './ConceptsBarItem';
import Image from '../atoms/Image';
import ScoreTable from './ScoreTable';
import useFitText from './FitText';
import type { Season } from '../../data/Seasons';
import { getImageByKey } from '../../assets/Assets';
import type { Round } from '../../store/PlaythroughSlice';

const Details = styled.div`
	color: ${(props) => props.theme.colors.white};
	display: flex;
	flex: 1;
	flex-direction: column;
	justify-content: flex-end;
	overflow: hidden;
`;

const Name = styled.span`
	overflow: hidden;
	white-space: nowrap;
`;

export interface Props {
	season: Season;
	round: Round;
}

const ActiveConceptsBarItem: FunctionComponent<Props> = (props: Props) => {
	const { season, round } = props;
	const concept = round.concept;
	const { fontSize, ref } = useFitText({
		minFontSize: 10,
		maxFontSize: 100,
		resolution: 5
	});

	if (!concept) {
		throw new Error('Round is not finished');
	}

	const conceptImage = useMemo(
		() => getImageByKey(concept.images.icon),
		[concept]
	);

	return (
		<ConceptsBarItem
			season={season}
			icon={
				<Image
					src={conceptImage}
					position="absolute"
					width="100%"
					height="100%"
				/>
			}
		>
			<Details>
				<Name ref={ref} style={{ fontSize }}>
					<Trans>{concept.texts.name}</Trans>
				</Name>
				<ScoreTable
					conceptScore={round.conceptScore}
					personaScores={round.personaScores}
				/>
			</Details>
		</ConceptsBarItem>
	);
};

export default ActiveConceptsBarItem;
